module.exports = __webpack_public_path__ + "img/erath-back.f0fc1205.webp";